import {
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const projectRiskCategoriesApi = createApi({
  reducerPath: "projectRiskCategoriesApi",
  baseQuery: fetchBaseQueryWrapper(),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getProjectRiskCategories: build.query({
      query: () => 'projectRiskCategories',
      transformResponse: (response: { data: { id: number; code: string; name: string }[] }) => response.data,
    }),
  }),
});

export const { useGetProjectRiskCategoriesQuery } = projectRiskCategoriesApi;
